module.exports = __webpack_public_path__ + "img/gregory_lemarchal.f9da1e69.jpg";